import axiosClient from './axiosClient';

export const getTeachers = (params?: Record<string, any>) => {
    return axiosClient.get('/teachers', { params });
};

export const createTeacher = (data: Record<string, any>) => {
    return axiosClient.post('/teachers', data);
};

export const updateTeacher = (id: string, data: Record<string, any>) => {
    return axiosClient.put(`/teachers/${id}`, data);
};

export const deleteTeacher = (id: string) => {
    return axiosClient.delete(`/teachers/${id}`);
};

export const uploadTeacherAvatar = (id: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosClient.post(`/teachers/${id}/avatar`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
export const getDashboardStats = () => {
    return axiosClient.get('/teachers/dashboard/stats');
};

export const getTeacherSubmissions = (params?: Record<string, any>) => {
    return axiosClient.get('/teachers/submissions', { params });
};

export const getSubmissionDetail = (submissionId: string) => {
    return axiosClient.get(`/teachers/submissions/${submissionId}`);
};

export const submitGrade = (submissionId: string, data: { score: number, feedback: string }) => {
    return axiosClient.patch(`/teachers/submissions/${submissionId}/grade`, data);
};

export const getTeacherTimetable = (params?: { teacher_id?: string; class_id?: string }) => {
    return axiosClient.get('/teachers/dashboard/timetable', { params });
};

export const generateAIGradingSuggestion = (submissionId: string) => {
    return axiosClient.post(`/teachers/submissions/${submissionId}/ai-grading`);
};
